// extracted by mini-css-extract-plugin
export var container = "index-module--container--fFYls";
export var emailHeader = "index-module--emailHeader--I7biX";
export var emailLink = "index-module--emailLink--W7yi-";
export var gradBorder = "index-module--gradBorder--fYI4U";
export var subtitle = "index-module--subtitle--WFbdd";